module.exports = __webpack_public_path__ + "resource/img/linkIcon.873c6fed.svg";